import React from "react";
import PropTypes from "prop-types";

import { Mutation } from "@apollo/client/react/components";
import { gql } from "@apollo/client";

import { OrderObject } from "../Queries/OrderQuery";
import shipmentFragments from "../Queries/graphql/shipmentFragments";

const SEND_TO_GP_GQL = gql`
  mutation sendToGp(
    $id: ID!
    $model: String!
    $flow: String!
    $syncId: String
  ) {
    sendToGp(id: $id, model: $model, flow: $flow, syncId: $syncId) {
      syncItem {
        id
      }
      errors {
        path
        message
      }
    }
  }
`;

const ORDER_QUERY = gql`
  query OrderDetails($orderId: Int!) {
    order(id: $orderId) {
      id
      uiState {
        allowProcessShipments
        allowResendShipments
      }
      resendableShipments {
        ...ShipmentQuery
      }
    }
  }
  ${shipmentFragments.query}
`;

class ResendShipmentMenuItem extends React.Component {
  render() {
    const { shipment, order, isResending, isDisabled } = this.props;
    
    return (
      <Mutation
        mutation={SEND_TO_GP_GQL}
        onError={this.onError}
        onCompleted={this.onCompleted}
        refetchQueries={[
          {
            query: ORDER_QUERY,
            variables: { orderId: parseInt(order.id) }
          }
        ]}
      >
        {(sendToGp, { loading, error }) => {
          const isProcessing = isResending || loading;
          const isClickable = !isProcessing && !isDisabled;
          
          return (
            <span
              onClick={isClickable ? () => this.handleResend(sendToGp) : null}
              className={
                "button__menu__link link-text" +
                (isProcessing ? " processing" : "") +
                (isDisabled ? " disabled" : "")
              }
            >
              {isProcessing ? (
                <span>
                  <i className="fa fa-spinner fa-spin" style={{ marginRight: "5px" }}></i>
                  Resending {shipment.invoiceNumber}...
                </span>
              ) : (
                `Resend ${shipment.invoiceNumber}`
              )}
            </span>
          );
        }}
      </Mutation>
    );
  }

  handleResend = (sendToGp) => {
    this.props.onResendStart(this.props.shipment.id);
    sendToGp({
      variables: {
        id: this.props.shipment.resendableSyncItem.id,
        model: this.props.shipment.resendableSyncItem.type,
        flow: this.props.shipment.resendableSyncItem.flow,
        syncId: this.props.shipment.resendableSyncItem.syncId
      }
    });
  };

  onCompleted = (result) => {
    this.props.onResendComplete();
  };

  onError = (error) => {
    console.log("onError occurred");
    console.log(error);
    this.props.onResendComplete();
  };
}

ResendShipmentMenuItem.propTypes = {
  shipment: PropTypes.object.isRequired,
  order: OrderObject.isRequired,
  onResendStart: PropTypes.func.isRequired,
  onResendComplete: PropTypes.func.isRequired,
  isResending: PropTypes.bool,
  isDisabled: PropTypes.bool
};

export default ResendShipmentMenuItem; 